import Image from "next/image"
import ImageWithLoader from "../shared/imageWithLoader/ImageWithLoader"
import type { ImageSizeVariant } from "@/app/lib/image-sizes"
import { IMediaCenterProps } from "./types"
import CustomButton from "../shared/CustomButton"
import parse from "html-react-parser"
import { useContext } from "react"
import { screenSizeContext } from "@/app/store/context/screenSizesContext"
import { usePopupContext } from "@/app/store/context/popupContext"

interface MediaCenterCardsProps {
  data: IMediaCenterProps
  isSecondInRow?: boolean
  twoCards?: boolean
  isOne?: boolean
  setActiveModal: (value: boolean) => void
  setModalData: (data: IMediaCenterProps | null) => void
  optimizedImage?: boolean
}

const MediaCenterCards = ({
  data,
  isSecondInRow,
  twoCards,
  isOne,
  setActiveModal,
  setModalData,
  optimizedImage,
}: MediaCenterCardsProps) => {
  const { isIpad } = useContext(screenSizeContext)
  const formatDate = (dateString?: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      // day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const {
    setisOtherPopupOpen,
    setPopupInnerData
  } = usePopupContext()

  const sizeVariant: ImageSizeVariant = twoCards ? "twoCol" : "threeCol"

  return (
    <div
      className={`media-center-card flex flex-col mb-[2.5rem] md:mb-[6.25rem] ${twoCards ? "w-[100%] md:w-[100%]" : " w-[100%]"
        }`}
    >
      {data?.card_image_desktop?.media_name &&
        data?.card_image_mobile?.media_name && (
          <div
            className={`image_wrapper relative mb-6 
          ${twoCards
                ? isOne
                  ? " lg:h-[26.9rem]  mt-0 md:mt-[1.88rem] md:h-[23.9rem] h-[21.3rem] m-0  md-[1.88rem]"
                  : "lg:h-[24.9rem] md:h-[20.9rem] h-[21.3rem] "
                : ""
              }
          ${!twoCards
                ? isSecondInRow
                  ? "lg:h-[21.3rem] md:h-[30rem] h-[21.3rem]"
                  : "lg:h-[25rem] md:h-[30rem] h-[21.3rem] "
                : ""
              } 
          `}
          >
            {optimizedImage ? (
              <ImageWithLoader
                src={
                  isIpad
                    ? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
                      data?.card_image_mobile?.media_name
                    : process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
                      data?.card_image_desktop?.media_name
                }
                alt={data.title?.en ?? "Media"}
                sizeVariant={sizeVariant}
                quality={75}
              />
            ) : (
              <Image
                src={
                  isIpad
                    ? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
                      data?.card_image_mobile?.media_name
                    : process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
                      data?.card_image_desktop?.media_name
                }
                alt={data.title?.en ?? "Media"}
                fill
                className="object-cover"
              />
            )}
            <div className="label absolute top-2 left-2  bg-white rounded-full px-4 py-2 font-national text-labelM ">
              {data.slug_label}
            </div>
          </div>
        )}
      <div className={`content `}>
        <div className="date font-national text-labelM text-oBlack-60 mb-4 lining-nums proportional-nums">
          {formatDate(data.date)}
        </div>
        <div className="title font-minerva-regular text-bodyL text-oBlack-100 mb-2">
          {data.title?.en}
        </div>
        <div className="desc font-national text-bodyM text-oBlack-60 mb-4">
          {data.card_description?.en ? parse(data.card_description.en) : null}
        </div>
        {/* <CustomButton
          action={() => {
            setActiveModal(true)
            setModalData(data)
          }}
          text="Learn More"
          hasIcon
          style="grey"
          customClass="w-fit"
        /> */}

        <CustomButton
          action={() => {
            setisOtherPopupOpen(true);
            setPopupInnerData(data);
          }}
          text="Learn More"
          hasIcon
          style="grey"
          customClass="w-fit"
        />
      </div>
    </div>
  )
}

export default MediaCenterCards
